import React, { useEffect } from "react"
import { useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  Card,
  Button,
  CardBody,
  Checkbox,
  CardFooter,
  CheckboxGroup,
  Chip,
} from "@nextui-org/react"
import { useEdit, useFetchWithBody } from "../../api/reactQueryCustomHooks.jsx"
import { LoadingCard, MainContainer } from "../../components/index.js"
import { apiRoute, linksUrl } from "../../constants/enum.js"

function EditUserMenuMapping() {
  const navigate = useNavigate()
  const { selectedUser } = useSelector((state) => state.userMaster)
  const { selectedClient } = useSelector((state) => state.clientMaster)
  const { appClientMapping } = useSelector((state) => state.appClientMapping)
  const {
    data: allAppMenu = [],
    isLoading: isAllAppMenuLoading,
    isFetching: isAllAppMenuFeatching,
  } = useFetchWithBody({
    url: apiRoute.userMenuMapping.read,
    queryKey: "allAppMenu",
    inputData: {
      userId: selectedUser.UserId,
      option: 3,
    },
  })


  const [selectedUserMenu, setSelectedUserMenu] = useState([])
  useEffect(() => {
    setSelectedUserMenu(allAppMenu.filter((item) => item.Id).map((item) => item.MenuId))
  }, [allAppMenu])
  const resetValues = () => { }

  const onSuccessTasks = () => {
    navigate(linksUrl.userMenuMapping.read)
  }

  const { isPending, mutate: editUserMenuMapping } = useEdit({
    url: apiRoute.userMenuMapping.edit,
    queryKey: "UserMenuMapping",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const onClickPrevPage = () => {
    navigate(linksUrl.userMenuMapping.read)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    editUserMenuMapping({
      data: {
        allAppMenu,
        selectedUserMenu,
        userId: selectedUser.UserId,
        client_code: selectedClient.client_code,
      },
    })
  }
  const allMenuIds = allAppMenu.map(item => item.MenuId);
  const isAllSelected = selectedUserMenu.length === allMenuIds.length;

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedUserMenu(allMenuIds); // select all
    } else {
      setSelectedUserMenu([]); // unselect all
    }
  };

  if (isAllAppMenuLoading || isAllAppMenuFeatching) {
    return <LoadingCard />
  }

  return (
    <MainContainer
      breadcrumbs={["User Master", "Menu Master", "Edit"]}
      pageName={"Edit Menu"}
      prevPage={{ show: true, onClick: onClickPrevPage }}
      headingCardProps={{
        show: true,
        items: [
          {
            heading: "Client",
            labels: [selectedClient.client_name, selectedClient.client_code],
          },
          {
            heading: "User",
            labels: [selectedUser.LoginName],
          },
          {
            heading: "App",
            labels: appClientMapping && appClientMapping.map((item) => item.AppName),
          },
        ],
      }}
    >
      <div className="mt-0 flex ">
        <div className=" w-full">
          <div className="m-5 rounded-md">
          <Checkbox
            isChecked={isAllSelected}
            isIndeterminate={
              selectedUserMenu.length > 0 &&
              selectedUserMenu.length < allMenuIds.length
            }
            onChange={(e) => handleSelectAll(e.target.checked)}
            className="bg-amber-100 text-blue-700"
            
            
          >
            Select All
          </Checkbox>
          </div>
          <Card className="max-w-[600px]" shadow="none" classNames="">
            <form onSubmit={handleSubmit}>
              <CardBody className="p-0">
                <div className="flex flex-col gap-0 mx-2">
                  <div className={`flex  h-[600px] flex-wrap md:flex-nowrap  md:mb-0 gap-4`}>
                    <CheckboxGroup
                      label=""
                      value={selectedUserMenu}
                      onValueChange={setSelectedUserMenu}
                    >
                      {allAppMenu.map((item) => {
                        return (
                          <div className={`flex ${item?.MenuParentId == null ? "bg-red-50 font-semibold uppercase text-xs" : ""} 
                           p-1 border-b-1 flex-wrap md:flex-nowrap  md:mb-0 gap-4`}>
                            <Checkbox key={item.MenuId} value={item.MenuId}>
                              <Chip size="sm" color="danger" variant="flat" className="mx-5"> {item?.Level} </Chip>
                              {item.MenuName}
                            </Checkbox>
                          </div>
                        )
                      })}
                    </CheckboxGroup>
                  </div>
                </div>
              </CardBody>
              <CardFooter>
                <Button color="primary" type="submit" isLoading={isPending}>
                  Edit Menu
                </Button>
              </CardFooter>
            </form>
          </Card>
        </div>
      </div>
    </MainContainer>
  )
}
export default EditUserMenuMapping
